import { render, staticRenderFns } from "./ServiceIssue.vue?vue&type=template&id=39f06b5c&scoped=true&"
import script from "./ServiceIssue.vue?vue&type=script&lang=js&"
export * from "./ServiceIssue.vue?vue&type=script&lang=js&"
import style0 from "./ServiceIssue.vue?vue&type=style&index=0&id=39f06b5c&lang=scss&scoped=true&"
import style1 from "./ServiceIssue.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f06b5c",
  null
  
)

export default component.exports